import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import FmbContributionsList from "./FmbContributionsList";
import FmbContributionsCreate from "./FmbContributionsCreate";
import FmbContributionsEdit from "./FmbContributionsEdit";
import FmbContributionsShow from "./FmbContributionsShow";

export default {
  list: FmbContributionsList,
  create: FmbContributionsCreate,
  edit: FmbContributionsEdit,
  show: FmbContributionsShow,
  icon: VolunteerActivismIcon,
  label: "FMB Contributions",
  options: { label: "FMB Contributions" },
  name: "fmbContributions",
};
